import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { NavigationProvider, useNavigation } from './contexts/NavigationContext';
import Header from './components/Header';
import Footer from './components/Footer';

// Views
import HomeView from './views/HomeView';
import PropertyPromotionView from './views/PropertyPromotionView';
import TenantScreeningView from './views/TenantScreeningView';
import EContractView from './views/EContractView';
import RentManagementView from './views/RentManagementView';
import MaintenanceView from './views/MaintenanceView';
import TechnicianDirectoryView from './views/TechnicianDirectoryView';
import InteriorDesignServiceView from './views/InteriorDesignServiceView';
import CommunicationSupportView from './views/CommunicationSupportView';
import ChatbotView from './views/ChatbotView';
import ContactView from './views/ContactView';

const MainContent = () => {
  const { currentView } = useNavigation();

  const renderView = () => {
    switch (currentView) {
      case 'home':
        return <HomeView />;
      case 'propertyPromotion':
        return <PropertyPromotionView />;
      case 'tenantScreening':
        return <TenantScreeningView />;
      case 'eContract':
        return <EContractView />;
      case 'rentManagement':
        return <RentManagementView />;
      case 'maintenance':
        return <MaintenanceView />;
      case 'technicianDirectory':
        return <TechnicianDirectoryView />;
      case 'interiorDesignService':
        return <InteriorDesignServiceView />;
      case 'communicationSupport':
        return <CommunicationSupportView />;
      case 'chatbot':
        return <ChatbotView />;
      case 'contact':
        return <ContactView />;
      default:
        return <HomeView />;
    }
  };

  return (
    <main className="flex-1 min-h-screen bg-gray-50">
      {renderView()}
    </main>
  );
};

function App() {
  return (
    <LanguageProvider>
      <NavigationProvider>
        <div className="flex flex-col min-h-screen">
          <Header />
          <MainContent />
          <Footer />
        </div>
      </NavigationProvider>
    </LanguageProvider>
  );
}

export default App;
